import { SvgIcon } from '@material-ui/core'

export default function SelectedCheckmarkIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <g transform="translate(-1,1)">
                <path
                    d="M18.5356 7L11.2005 14.3425L9 12.142"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </SvgIcon>
    )
}
